import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  description?: string;
  morePath?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  kicker,
  title,
  description,
  morePath,
  moreLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="mb-7 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <div className="mb-2 flex items-center gap-2">
          <span className="h-3.5 w-1 rounded-full bg-primary-500"></span>
          {kicker ? (
            <span className="text-xs tracking-[0.22em] text-primary-400">{kicker}</span>
          ) : null}
        </div>
        <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">{title}</h2>
        {description ? (
          <p className="mt-2.5 max-w-2xl text-sm leading-relaxed text-foreground-500">{description}</p>
        ) : null}
      </div>
      {morePath ? (
        <Link
          to={morePath}
          className="inline-flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/70 px-4 py-2 text-sm text-foreground-300 transition-colors hover:border-primary-500/60 hover:text-primary-400"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      ) : null}
    </div>
  );
}